import {jwtDecode} from 'jwt-decode'
import {useSnackbar} from 'notistack'
import {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import {useAuth} from 'src/contexts/AuthContext'
import {buildNewPortalAuthUrl, redirectToNewPortalAuth} from 'src/lib/portal-migration/build-new-portal-auth-url'

export default function HandleRedirectWithTokenOnUrl() {
  const {authFromUrlToken, logout: clearStorage} = useAuth()
  const navigate = useNavigate()
  const rawUrl = window.location.href
  const decodedUrl = decodeURIComponent(rawUrl)
  const queryString = decodedUrl.split('?')[1]
  const params = new URLSearchParams(queryString)
  const next = params.get('next')

  const token = params.get('token')
  const {enqueueSnackbar} = useSnackbar()

  function goToLogin() {
    try {
      localStorage.removeItem('redirectToAfterLogin')
    } catch {
      // ignore
    }
    if (redirectToNewPortalAuth('/login')) return
    navigate('/login')
  }

  async function redirectToNext() {
    if (token) {
      clearStorage()
      const otpDecoded = jwtDecode(token) as {operation?: string}
      if (otpDecoded.operation === 'define-password') {
        const target = buildNewPortalAuthUrl('/define-password')
        if (target) {
          const url = new URL(target)
          url.searchParams.set('token', token)
          window.location.replace(url.toString())
          return
        }
        if (redirectToNewPortalAuth('/define-password')) return
        return navigate(`/define-password?token=${encodeURIComponent(token)}`)
      }
      const userIsAuthRedirectToNext = await authFromUrlToken(token)
      if (userIsAuthRedirectToNext) return navigate(`/${next}`)

      enqueueSnackbar('Erro ao autenticar código recebido por e-mail', {variant: 'error'})
      return goToLogin()
    }
    goToLogin()
  }

  useEffect(() => {
    redirectToNext()
  }, [])

  return <></>
}
